export const scales_index = ['scales.index']
export const scales_create = ['scales.create']
export const scales_edit = ['scales.edit']

export default [].concat(
    scales_index,
    scales_create,
    scales_edit
)
